export { EventBoundary } from './EventBoundary.mjs';
export { EventSystem } from './EventSystem.mjs';
export { FederatedEvent } from './FederatedEvent.mjs';
import './FederatedEventMap.mjs';
export { FederatedDisplayObject } from './FederatedEventTarget.mjs';
export { FederatedMouseEvent } from './FederatedMouseEvent.mjs';
export { FederatedPointerEvent } from './FederatedPointerEvent.mjs';
export { FederatedWheelEvent } from './FederatedWheelEvent.mjs';
//# sourceMappingURL=index.mjs.map
